var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoueeDeSauvetage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 971,
    height: 971,
    viewBox: "0 0 971 971",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M388.969 337.8C449.088 305.18 521.723 305.18 581.841 337.8C591.134 342.92 602.513 341.213 609.909 333.817L779.834 163.892C790.075 153.651 788.938 136.772 777.369 128.238C604.979 -2.61934 366.022 -2.61934 193.441 128.048C181.873 136.772 180.925 153.651 190.976 163.702L360.901 333.627C368.297 341.213 379.866 342.73 388.969 337.8Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M827.073 172.201L643.493 355.781C633.252 366.022 630.787 381.952 637.425 394.848C666.061 451.743 666.061 519.068 637.425 576.152C630.787 589.238 633.252 604.979 643.493 615.22L800.143 771.87C814.936 786.662 839.211 784.576 851.348 767.697C979.93 588.669 971.775 342.885 827.073 172.201Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M585.883 637.358C523.868 672.822 447.629 672.822 385.425 637.358C378.597 633.375 369.874 634.513 364.374 640.203L186.104 818.662C178.708 826.058 179.467 838.385 187.621 844.833C362.667 981.57 608.831 981.57 783.687 844.833C791.841 838.385 792.6 826.248 785.204 818.662L606.744 640.203C601.434 634.703 592.71 633.565 585.883 637.358Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M332.454 586.962C296.042 524.378 296.042 446.812 332.454 384.228C336.058 378.159 334.92 370.384 329.989 365.263L149.254 184.528C142.616 177.891 131.617 178.46 125.927 185.856C-12.5161 361.47 -12.5161 609.53 125.927 785.145C131.806 792.541 142.616 793.11 149.254 786.473L329.989 605.737C335.109 600.807 336.058 593.031 332.454 586.962Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoueeDeSauvetage);
export default __webpack_public_path__ + "static/media/bouee-de-sauvetage.db52fa98131b2b0ba23f118249bfdb44.svg";
export { ForwardRef as ReactComponent };